import ProjectDrawingsIndex from "./index";

export default [{ path: "/project/drawings", component: ProjectDrawingsIndex, name: "Project Drawings" }];

// import ProjectDrawingsRoutes from "modules/project/drawings/mobile/routes"
// routes = _.concat(routes,ProjectDrawingsRoutes)
